module.exports = __webpack_public_path__ + "img/php_logo.b15cce40.jpg";